/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mainTabsContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  buttonTab: {
    flex: "1 1 auto",
    border: "none",
    background: "none",
    padding: "0px 5px 0px 5px",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    position: "relative",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  labelTab: {
    marginBottom: "5px",
    textWrap: "nowrap",
    fontSize: "inherit",
    fontFamily: "inherit",
    fontWeight: "bold",
    [theme.breakpoints.up(2560)]: { fontSize: "19px" },
    [theme.breakpoints.between(1920, 2560)]: { fontSize: "17px" },
    [theme.breakpoints.between(1440, 1920)]: { fontSize: "15px" },
    [theme.breakpoints.between(1280, 1440)]: { fontSize: "14px" },
    [theme.breakpoints.down(1280)]: { fontSize: "14px" },
  },
  activeSpan: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    width: "0%",
    height: "3px",
    backgroundColor: "#e86861",
    transform: "translateX(-50%) scaleX(0)",
    transformOrigin: "center",
    transition: "transform 0.4s ease-out",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  activeSpanVisible: {
    transform: "translateX(-50%) scaleX(1)",
    width: "100%",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  tabWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
    flexDirection: "row",
    justifyContent: "center",
  },
  newFeature: {
    backgroundColor: "#e86861",
    color: "#ffffff",
    padding: "2px 6px",
    borderRadius: "12px",
    fontSize: "10px",
    fontFamily: "inherit",
    textTransform: "uppercase",
    marginBottom: "3px",
  },
}));

const activeTabs = { 0: true, 1: true };

export default function SummaryTabs({ setCurrentTab }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  // // Set default tab to "Promotions" on component mount for NewFeatAnnouncement
  // useEffect(() => {
  //   setCurrentTab(1);
  //   setValue(1);
  // }, []);

  return (
    <div className={classes.mainTabsContainer}>
      {[...Array(5)].map((_, index) => (
        <button
          key={index}
          type="button"
          id={index}
          className={classes.buttonTab}
          onClick={() => {
            setValue(index);
            setCurrentTab(index);
          }}
          disabled={!activeTabs[index]}
        >
          <div className={classes.tabWrapper}>
            {/* new feature tab */}
            {index === 1 && <span className={classes.newFeature}>new</span>}
            <div className={classes.labelTab}>
              {
                [
                  "Decision matrix",
                  "Promotions",
                  "Comparison detailed",
                  "Price changes",
                  "Weekly summary",
                ][index]
              }
            </div>
          </div>
          <span
            className={`${classes.activeSpan} ${value === index &&
              classes.activeSpanVisible}`}
          />
        </button>
      ))}
    </div>
  );
}
